import { Container, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Logo from '../logo'

export default function AppHeader({ action }) {
    const { t } = useTranslation()

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}
        >
            <Container maxWidth="lg">
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ minHeight: 64 }}>
                    <Stack direction="row" alignItems="center">
                        <Logo
                            sx={{
                                width: 52,
                                height: 52,
                            }}
                        />
                        <Typography
                            fontWeight={800}
                            color="primary"
                            sx={{
                                fontSize: (theme) => theme.typography.h4.fontSize,
                                fontFamily: (theme) => theme.typography.h1.fontFamily,
                            }}
                        >
                            {t('appName')}
                        </Typography>
                    </Stack>
                    {action}
                </Stack>
            </Container>
        </Container>
    )
}
